import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import AdminRoute from "@/components/AdminRoute";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import VerifyDocument from "@/pages/VerifyDocument";
import AuthCallback from "@/pages/AuthCallback";
import Dashboard from "@/pages/Dashboard";
import Jobs from "@/pages/Jobs";
import DailyEntries from "@/pages/DailyEntries";
import Attendance from "@/pages/Attendance";
import Invoices from "@/pages/Invoices";
import Files from "@/pages/Files";
import Reminders from "@/pages/Reminders";
import Team from "@/pages/Team";
import LocalUsers from "@/pages/Users";
import Workflow from "@/pages/Workflow";
import Leaderboard from "@/pages/Leaderboard";
import Integrations from "@/pages/Integrations";
import Clients from "@/pages/Clients";
import ClientDetail from "@/pages/ClientDetail";
import Vendors from "@/pages/Vendors";
import Expenses from "@/pages/Expenses";
import Email from "@/pages/Email";
import Organizations from "@/pages/Organizations";
import BillingSuccess from "@/pages/BillingSuccess";
import BillingCancel from "@/pages/BillingCancel";
import PendingApprovals from "@/pages/PendingApprovals";
import SearchPage from "@/pages/SearchPage";
import Documentation from "@/pages/Documentation";

function AppRouter() {
  const location = useLocation();
  // Synchronous check for OAuth callback (before any other routing)
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/verify" element={<VerifyDocument />} />
      <Route path="/" element={<Navigate to="/dashboard" replace />} />
      <Route element={<ProtectedRoute><Layout /></ProtectedRoute>}>
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/jobs" element={<Jobs />} />
        <Route path="/daily-entries" element={<DailyEntries />} />
        <Route path="/attendance" element={<Attendance />} />
        <Route path="/invoices" element={<AdminRoute><Invoices /></AdminRoute>} />
        <Route path="/files" element={<Files />} />
        <Route path="/reminders" element={<AdminRoute><Reminders /></AdminRoute>} />
        <Route path="/team" element={<Team />} />
        <Route path="/users" element={<AdminRoute allowHr><LocalUsers /></AdminRoute>} />
        <Route path="/workflow" element={<Workflow />} />
        <Route path="/leaderboard" element={<Leaderboard />} />
        <Route path="/integrations" element={<AdminRoute><Integrations /></AdminRoute>} />
        <Route path="/clients" element={<Clients />} />
        <Route path="/clients/:id" element={<AdminRoute><ClientDetail /></AdminRoute>} />
        <Route path="/vendors" element={<Vendors />} />
        <Route path="/expenses" element={<AdminRoute><Expenses /></AdminRoute>} />
        <Route path="/email" element={<Email />} />
        <Route path="/organizations" element={<AdminRoute><Organizations /></AdminRoute>} />
        <Route path="/billing/success" element={<BillingSuccess />} />
        <Route path="/billing/cancel" element={<BillingCancel />} />
        <Route path="/pending-approvals" element={<AdminRoute allowHr><PendingApprovals /></AdminRoute>} />
        <Route path="/search" element={<SearchPage />} />
        <Route path="/documentation" element={<Documentation />} />
      </Route>
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRouter />
        <Toaster position="top-right" theme="light" richColors closeButton duration={6000} toastOptions={{
          style: { background: "#fff", border: "1px solid #18181B", borderRadius: 0, fontFamily: "IBM Plex Mono", boxShadow: "2px 2px 0 0 #18181B" }
        }} />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
